import React, { Component } from "react";
import axios from "axios";
import { getUser } from "../../../../../actions/session";
import { Notifications } from "../../../../common/notification";
import { ACCOUNT_LISTING, ACCOUNT_TAB_STIR_SHAKEN } from "../../../../../config/rest_endpoints";

class CarrierAddSubjectBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      User: getUser(),
      subject: "",
      note: "",
      isLoad: false,
      msg: "",
      userId: this.props.accountID,
      accounts: [],
      selectedAccounts: [],
      allSelected: true,
      isAccountLoading: false
    };

    this.onHandleChange = this.onHandleChange.bind(this);
    this.onSubmitChange = this.onSubmitChange.bind(this);
    this.handleAccountChange = this.handleAccountChange.bind(this);
    this.handleAllAccountsChange = this.handleAllAccountsChange.bind(this);
  }

  componentDidMount() {
    this.fetchAccounts();
  }

  fetchAccounts() {
    const { User } = this.state;
    this.setState({ isAccountLoading: true });
    
    const headers = { Authorization: `Bearer ${User.token}` };
    
    axios.get(ACCOUNT_LISTING, { headers })
      .then((res) => {
        if (res.data && res.data.data) {
          const accountsData = res.data.data;
          console.log("accountsData", accountsData)
          // Set all accounts as selected by default
          const allAccountIds = accountsData.map(account => account.id);
          this.setState({ 
            accounts: accountsData,
            selectedAccounts: allAccountIds,
            allSelected: true,
            isAccountLoading: false 
          });
        }
      })
      .catch((err) => {
        console.error('Error fetching accounts:', err);
        this.setState({ isAccountLoading: false });
        Notifications.notify("Failed to fetch accounts", "Error", "error");
      });
  }

  handleAllAccountsChange(e) {
    const { accounts } = this.state;
    const allSelected = e.target.checked;
    
    if (allSelected) {
      // Select all accounts
      const allAccountIds = accounts.map(account => account.id);
      this.setState({ 
        allSelected: true, 
        selectedAccounts: allAccountIds 
      });
    } else {
      // Deselect all accounts
      this.setState({ 
        allSelected: false, 
        selectedAccounts: [] 
      });
    }
  }

  handleAccountChange(accountId) {
    const { selectedAccounts, accounts } = this.state;
    let newSelectedAccounts;
    
    if (selectedAccounts.includes(accountId)) {
      // Remove account from selection
      newSelectedAccounts = selectedAccounts.filter(id => id !== accountId);
    } else {
      // Add account to selection
      newSelectedAccounts = [...selectedAccounts, accountId];
    }
    
    // Check if all accounts are selected
    const allSelected = newSelectedAccounts.length === accounts.length;
    
    this.setState({ 
      selectedAccounts: newSelectedAccounts,
      allSelected: allSelected
    });
  }

  onHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  clearForm() {
    this.setState({ 
      subject: "", 
      note: "",
      selectedAccounts: [],
      allSelected: true
    });
  }

  onSubmitChange() {
    const { subject, note, User, userId, selectedAccounts, accounts } = this.state;
    const { accountID } = this.props;
    console.log("accountID", accountID);
    if (!subject) {
      Notifications.notify("All form fields are required", "Error", "error");
      return;
    }

    // Prepare blockedAccountsID array
    let blockedAccountsID = [];
    if (this.state.allSelected) {
      // If "All" is selected, send all account IDs
      blockedAccountsID = accounts.map(account => account.id);
    } else {
      // Send only selected account IDs
      blockedAccountsID = selectedAccounts;
    }

    const payload = {
      accountID: accountID,
      stirShakenSubject: subject,
      note,
      blockedAccountsID,
      tab: "carrier"
    };

    console.log("payload", payload)
    this.setState({ isLoad: true });

    const headers = { Authorization: `Bearer ${User.token}` };

    axios
      .post(`${ACCOUNT_TAB_STIR_SHAKEN}`, payload, { headers })
      .then((res) => {
        this.setState({ msg: res.data.message, isLoad: false });
        this.props.close();
        this.props.listingServer();
        this.clearForm();
        Notifications.notify(res.data.message, "Created", "success");
      })
      .catch((err) => {
        let message = "Something went wrong";
        if (err.response && err.response.data && err.response.data.message) {
          message = err.response.data.message;
        } else if (err.message) {
          message = err.message; // Fallback for network errors
        }
        this.setState({ isLoad: false });
        Notifications.notify(message, "Failed", "error");
      });
  }

  render() {
    const { subject, note, isLoad, accounts, selectedAccounts, allSelected, isAccountLoading } = this.state;
    console.log("accounts", accounts)

    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <label style={{ fontWeight: "400", fontSize: "16px" }}>
                Stir Shaken Subject
              </label>
              <input
                type="text"
                className="form-control"
                name="subject"
                value={subject}
                onChange={this.onHandleChange}
                placeholder="Enter subject"
              />
            </div>
          </div>
          
          <div className="col-md-12">
            <div className="form-group">
              <label style={{ fontWeight: "400", fontSize: "16px" }}>
                Accounts
              </label>
              <div>
                <div className="form-check mb-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="allAccounts"
                    checked={allSelected}
                    onChange={this.handleAllAccountsChange}
                  />
                  <label className="form-check-label" htmlFor="allAccounts">
                    <strong>All Accounts</strong>
                  </label>
                </div>
                
                {accounts && accounts.length > 0 && (
                  <div style={{ maxHeight: '150px', overflowY: 'auto', border: '1px solid #ddd', padding: '10px', borderRadius: '4px' }}>
                    {accounts.map((account) => (
                      <div key={account.id} className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`account-${account.id}`}
                          checked={selectedAccounts.includes(account.id)}
                          onChange={() => this.handleAccountChange(account.id)}
                        />
                        <label className="form-check-label" htmlFor={`account-${account.id}`}>
                          {account.name || account.accountName || `Account ${account.id}`}
                        </label>
                      </div>
                    ))}
                  </div>
                )}
                
                {(!accounts || accounts.length === 0) && (
                  <div style={{ padding: '10px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#f8f9fa' }}>
                    <small className="text-muted">No accounts available</small>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-md-12">
            <div className="form-group">
              <label style={{ fontWeight: "400", fontSize: "16px" }}>
                Note
              </label>
              <textarea
                className="form-control"
                name="note"
                value={note}
                onChange={this.onHandleChange}
                placeholder="Enter note"
                rows="4"
              />
            </div>
          </div>
        </div>
        <div className="row" style={{ borderTop: "1px solid #e9ecef" }}>
          <div className="col-md-6 ml-auto">
            <button
              type="submit"
              className="mt-2 main-button btn btn-sm btn-success float-right"
              disabled={isLoad}
              onClick={this.onSubmitChange}
            >
              Add{" "}
              {isLoad ? (
                <i className="fas fa-spinner fa-spin ml-1"></i>
              ) : (
                <i className="icon-file-plus ml-1 icon-1x"></i>
              )}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default CarrierAddSubjectBlock;
